
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface AdMetaProps {
  title?: string;
  description?: string;
  imageUrl?: string;
}

const AdMeta: React.FC<AdMetaProps> = ({ 
  title = "Sparkwave AI - Transform Your Business With AI",
  description = "Powerful AI solutions to automate processes, enhance customer experiences, and drive business growth.",
  imageUrl,
}) => {
  // Get the absolute base URL
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://sparkwaveai.net';
  const logoPath = imageUrl || `${baseUrl}/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png`;
  const currentUrl = `${baseUrl}/ad-landing`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={logoPath} />
      <meta property="og:image:alt" content="Sparkwave AI Logo" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Sparkwave AI" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={logoPath} />
      
      {/* LinkedIn */}
      <meta property="linkedin:title" content={title} />
      <meta property="linkedin:description" content={description} />
      <meta property="linkedin:image" content={logoPath} />
      
      {/* Telegram */}
      <meta property="telegram:title" content={title} />
      <meta property="telegram:description" content={description} />
      <meta property="telegram:image" content={logoPath} />
      
      {/* Cache control */}
      <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      <meta http-equiv="Pragma" content="no-cache" />
      <meta http-equiv="Expires" content="0" />
    </Helmet>
  );
};

export default AdMeta;
